import { Col } from 'antd';

const HVCol = props => {
    return <Col {...props} />;
};

export default HVCol;
